import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useAddTeamsMutation } from "../../features/teams/teamsApi";

export default function Modal({ open, control }) {
  // state
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [color, setColor] = useState("#000000");

  // self login data
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};
  const { email: myEmail } = loggedInUser || {};

  const [addTeams, { isSuccess: isAddTeamSuccess }] = useAddTeamsMutation();

  const handleSubmit = (e) => {
    e.preventDefault();

    addTeams({
      data: {
        title: title,
        description: description,
        color: color || "#000000",
        timestamp: new Date().getTime(),
        teamMember: `${myEmail}`,
        teamUsers: [{ ...loggedInUser, isAdmin: true }],
      },
    });
  };

  // listen conversation add/edit success
  useEffect(() => {
    if (isAddTeamSuccess) {
      // modal hide
      control();

      // reset
      setColor("");
      setDescription("");
      setTitle("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAddTeamSuccess]);

  return (
    open && (
      <>
        <div
          onClick={() => {
            control();
            setColor("");
            setDescription("");
            setTitle("");
          }}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Add Team
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <input type="hidden" name="remember" value="true" />
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label className="sr-only">Title</label>
                <input
                  id="title"
                  name="title"
                  type="text"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Title"
                  onChange={(e) => {
                    e.stopPropagation();
                    setTitle(e.target.value);
                  }}
                />
              </div>
              <div>
                <label htmlFor="message" className="sr-only">
                  Description
                </label>
                <textarea
                  id="description"
                  name="description"
                  type="text"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div>
                <label className="sr-only">Color</label>
                <input
                  id="color"
                  name="color"
                  type="color"
                  required
                  // className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  // placeholder="Color"
                  onChange={(e) => {
                    e.stopPropagation();
                    setColor(e.target.value);
                  }}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </>
    )
  );
}
